module.exports = __webpack_public_path__ + "static/media/roadmap.1bac37b0.png";